"use strict";

exports.__esModule = true;
exports.renderNode = exports.renderMark = void 0;
var _react = _interopRequireDefault(require("react"));
var _nodes = require("./nodes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Render a Slate node.
 *
 * @param {Object} props
 * @param {Function} next
 * @return {Element}
 */

const renderNode = (props, editor, next) => {
  const {
    attributes,
    children,
    node
  } = props;
  switch (node.type) {
    case 'block-quote':
      return /*#__PURE__*/_react.default.createElement("blockquote", attributes, children);
    case 'bulleted-list':
      return /*#__PURE__*/_react.default.createElement("ul", attributes, children);
    case 'heading-one':
      return /*#__PURE__*/_react.default.createElement("h1", attributes, children);
    case 'heading-two':
      return /*#__PURE__*/_react.default.createElement("h2", attributes, children);
    case 'list-item':
      return /*#__PURE__*/_react.default.createElement("li", attributes, children);
    case 'numbered-list':
      return /*#__PURE__*/_react.default.createElement("ol", attributes, children);
    case 'link':
      return /*#__PURE__*/_react.default.createElement(_nodes.LinkNode, props);
    default:
      return next();
  }
};

/**
 * Render a Slate mark.
 *
 * @param {Object} props
 * @return {Element}
 */
exports.renderNode = renderNode;
const renderMark = (props, editor, next) => {
  const {
    children,
    mark,
    attributes
  } = props;
  switch (mark.type) {
    case 'bold':
      return /*#__PURE__*/_react.default.createElement("strong", attributes, children);
    case 'code':
      return /*#__PURE__*/_react.default.createElement("code", attributes, children);
    case 'italic':
      return /*#__PURE__*/_react.default.createElement("em", attributes, children);
    case 'underlined':
      return /*#__PURE__*/_react.default.createElement("u", attributes, children);
    default:
      return next();
  }
};
exports.renderMark = renderMark;